export default __webpack_public_path__ + "static/media/aut1.55447f7b.jpeg";